import { Link } from 'react-router-dom';
import { CUSTOMER_PORTAL_ROUTES } from '@/routes/customer-portal-routes';

export function CustomerPortalNotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-customer-bg p-8 text-center">
      <span className="text-7xl font-bold text-customer-text-secondary">404</span>
      <h1 className="text-2xl font-semibold text-customer-text">Page not found</h1>
      <p className="text-customer-text-secondary">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to={CUSTOMER_PORTAL_ROUTES.DASHBOARD}
        className="mt-2 inline-flex min-h-11 items-center rounded-lg bg-customer-primary px-4 py-2 text-sm font-medium text-customer-action-ink hover:bg-customer-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-customer-ring"
      >
        Back to Dashboard
      </Link>
    </div>
  );
}
